import { motion } from "framer-motion";
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope } from "react-icons/fa";
import Typewriter from "typewriter-effect";
import Me from "../images/WhatsApp Image 2025-11-23 at 8.30.16 PM.jpeg";
import Resume from "../images/Soumya_KP_Resume.docx";

export default function Home() {
  return (
    <section
      id="home"
      className="min-h-screen flex items-center justify-center overflow-hidden  px-4 sm:px-6"
    >
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="relative max-w-4xl mx-auto z-10 w-full"
      >
        <div
          className="grid grid-cols-1 lg:grid-cols-[1.2fr_1fr]  items-center 
                    px-6 sm:px-6 py-8 
                    bg-white/5 backdrop-blur-md border border-white/20 
                    rounded-2xl shadow-lg transition-all duration-300 
                    hover:shadow-[0_0_10px_2px_rgba(0,255,255,0.2)]"
        >
          {/* Text content */}
          <div className="order-2 lg:order-1 text-center lg:text-left">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 2 }}
            >
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple">
                  Hello{" "}
                </span>{" "}
                I'm
              </h2>
              <div className="w-32 sm:w-40 h-1 bg-gradient-to-r from-neon-pink to-neon-purple mb-6 sm:mb-8 mx-auto lg:mx-0 rounded-full"></div>

              {/* Name typing */}
              <div className="text-2xl sm:text-3xl md:text-4xl font-semibold text-neon-cyan mb-4">
                <Typewriter
                  options={{
                    strings: ["Mr Soumya KP ...."],
                    autoStart: true,
                    loop: false,
                    delay: 75,
                    deleteSpeed: Infinity,
                  }}
                />
              </div>

              {/* Roles typing (looping) */}
              <div className="text-xl sm:text-2xl text-transparent bg-clip-text bg-gradient-to-r from-neon-cyan to-neon-purple min-h-[60px] sm:min-h-[46px]">
                <Typewriter
                  options={{
                    strings: [
                      "An Electronics Engineer ",
                      "An Full Stack Web Developer 💻",
                      "An CP Enthusiast 🏆",
                      "An Space Enthusiast 🚀",
                    ],
                    autoStart: true,
                    loop: true,
                    delay: 50,
                    deleteSpeed: 30,
                  }}
                />
              </div>

              <p className="text-base sm:text-lg text-gray-300 mb-6 leading-relaxed">
                I specialize in modern web technologies, crafting performant and accessible
                applications.
              </p>
            </motion.div>

            {/* Social links */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 1 }}
              className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 mt-6"
            >
              <div className="flex gap-4">
                <a
                  href="https://github.com/soumya16kp"
                  className="text-gray-400 hover:text-neon-cyan text-2xl transition-all duration-300 hover:-translate-y-1"
                  aria-label="GitHub"
                >
                  <FaGithub />
                </a>
                <a
                  href="https://www.linkedin.com/in/soumya-kp-700503369/"
                  className="text-gray-400 hover:text-neon-purple text-2xl transition-all duration-300 hover:-translate-y-1"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-neon-purple text-2xl transition-all duration-300 hover:-translate-y-1"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </a>
                <a
                  href="mailto:soumya16kp.work@gmail.com"
                  className="text-gray-400 hover:text-neon-cyan text-2xl transition-all duration-300 hover:-translate-y-1"
                  aria-label="Email"
                >
                  <FaEnvelope />
                </a>
              </div>
              <a
                href={Resume}
                download="Soumya_KP_Resume.docx"
                className="relative inline-flex items-center gap-2 px-6 py-3 rounded-xl
                          bg-white/10 backdrop-blur-md text-white/90
                          border border-white/20 shadow-[0_8px_24px_rgba(0,0,0,0.25)]
                          hover:bg-white/15 hover:border-white/30 hover:shadow-[0_0_24px_#00ffff40]
                          active:scale-95 transition-all duration-300 text-sm sm:text-base"
              >
                Download Resume
              </a>
            </motion.div>
          </div>

          {/* Image container */}
          <div className="order-1 lg:order-2 relative w-64 h-64 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-72 lg:h-72 mx-auto flex items-center justify-center">
            {/* Pulsing Border Ring */}
            <div className="absolute inset-0 rounded-full border-4 border-neon-cyan shadow-[0_0_30px_#00ffff40] animate-pulse-neon text-neon-cyan z-20 pointer-events-none"></div>

            <div className="relative w-full h-full rounded-full overflow-hidden z-10">
              <img
                src={Me}
                alt="Profile Image"
                className="w-full h-full object-cover object-center scale-110"
                style={{
                  objectPosition: "50% 50%",
                  // Adjust this value to position the face properly
                  transform: "scale(1.2)"
                }}
              />
            </div>

            {/* Optional decorative glow */}
            <div className="absolute inset-0 rounded-full bg-neon-cyan/20 blur-xl -z-10 scale-110 animate-pulse-neon text-neon-cyan"></div>
          </div>
        </div>
      </motion.div>
    </section>
  );
}